import styled, { css } from 'styled-components';
import { StatusNamesType } from './types';

export const StepContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.gray4D};
  font-size: 16px;
  font-weight: 700;
`;
export const Content = styled.div<{ width: string }>`
  align-items: flex-end;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-left: 6px;
  width: ${({ width }) => (width ? `${width}` : `200px`)};
`;
export const Subtitle = styled.div`
  color: ${({ theme }) => theme.grayB8};
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
`;

export const TitleSubtitleContainer = styled.div`
  margin: 6px;
  margin-bottom: 0px;
`;

export const BasicIconContainer = styled.div`
  margin: 7px;
`;

export const Pipe = styled.div<{ status: StatusNamesType; height: Number; isLastElement: boolean }>`
  background-color: ${({ theme, status }) =>
    status === 'success' ? theme.statusStepper.success : theme.statusStepper.cancel};
  height: ${({ height }) => `${height}px`};
  left: 15px;
  position: relative;
  visibility: ${({ isLastElement }) => isLastElement && `hidden`};
  width: 2px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  left: 40px;
  position: absolute;
  top: 0px;
  width: calc(100% - 40px);
`;

export const StepInfoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

export const StatusStepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const IconBackground = styled.div<{ status: StatusNamesType }>`
  align-items: center;
  background-color: ${({ status, theme }) =>
    status === 'success' ? theme.status.success.opacity : theme.status.error.opacity};
  border-radius: 50%;
  display: flex;
  height: 18px;
  justify-content: center;
  width: 18px;
`;

export const ContentText = styled.div<{ expanded: Boolean }>`
  color: ${({ theme }) => theme.gray2D};
  ${({ expanded }) =>
    !expanded &&
    css`
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  margin: 0;
  overflow-wrap: break-word;
  white-space: pre-line;
  width: 100%;
`;

export const StepButtonContainer = styled.div`
  max-width: 200px;
  overflow: hidden;
  position: relative;
  text-overflow: 'ellipsis';
  white-space: nowrap;
`;

export const SeeMoreContainer = styled.div`
  min-width: 70px;
`;
